var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellBoldFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_2922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6682 0.679199C9.97679 0.679199 9.4182 1.23779 9.4182 1.9292V2.6792C6.56663 3.25732 4.4182 5.78076 4.4182 8.8042V9.53857C4.4182 11.3745 3.74242 13.1479 2.52367 14.5229L2.2346 14.8472C1.90648 15.2144 1.82835 15.7417 2.02757 16.1909C2.22679 16.6401 2.67601 16.9292 3.1682 16.9292H18.1682C18.6604 16.9292 19.1057 16.6401 19.3088 16.1909C19.5119 15.7417 19.4299 15.2144 19.1018 14.8472L18.8127 14.5229C17.594 13.1479 16.9182 11.3784 16.9182 9.53857V8.8042C16.9182 5.78076 14.7698 3.25732 11.9182 2.6792V1.9292C11.9182 1.23779 11.3596 0.679199 10.6682 0.679199ZM12.4377 19.9487C12.9065 19.48 13.1682 18.8433 13.1682 18.1792H10.6682H8.1682C8.1682 18.8433 8.42992 19.48 8.89867 19.9487C9.36742 20.4175 10.0041 20.6792 10.6682 20.6792C11.3323 20.6792 11.969 20.4175 12.4377 19.9487Z",
    fill: "#08576C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_2922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.668945 0.679199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBoldFill);
export default __webpack_public_path__ + "static/media/bell-bold-fill.5da05eab51c01768d53d71e7fae3b5e3.svg";
export { ForwardRef as ReactComponent };